import React, {createContext, useMemo} from 'react';

const defaultFlags = {
  Cart: true,
  Argo: true,
  CrypticCollab: true,
  StarterUpgradePath: true,
  CollabsBanner: true,
  PageBuilderV2: true,
} as const;

export const FeatureFlags = createContext<{[key: string]: boolean}>({});

export interface Flags {
  [key: string]: boolean;
}

interface FeatureFlagsProviderProps {
  flags?: Flags;
  queryString?: string;
  children: React.ReactNode;
}

interface FlagProviderProps {
  value: string;
  children: React.ReactNode;
}

export function FeatureFlagsProvider({
  flags = defaultFlags,
  queryString = '',
  children,
}: FeatureFlagsProviderProps) {
  const featureFlags = useMemo(() => {
    const flagsFromUrl = extractFlagsFromQueryString(queryString);
    return {
      ...flags,
      ...flagsFromUrl,
    };
  }, [queryString, flags]);
  return (
    <FeatureFlags.Provider value={featureFlags}>
      {children}
    </FeatureFlags.Provider>
  );
}

export function Flag({value, children}: FlagProviderProps) {
  function matching(string: string, flags: Flags) {
    return flags[string];
  }

  return (
    <FeatureFlags.Consumer>
      {(flags) => {
        if (matching(value, flags)) {
          return children;
        }
        return null;
      }}
    </FeatureFlags.Consumer>
  );
}

function extractFlagsFromQueryString(queryString: string): {
  [flag: string]: boolean;
} {
  const flags = new URLSearchParams(queryString).get('featureFlags');
  if (!flags) {
    return {};
  }

  return flags.split(',').reduce((acc, flagName) => {
    return {
      ...acc,
      [flagName]: true,
    };
  }, {});
}
